import graphql__3bf326f8db9b0437ca53 from "./__generated__/ParticipativeModuleResultsFormFieldContainer_result.graphql.js";import { useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import { useFormatMessage } from "../Intl/Context";

const ParticipativeModuleResultsFormFieldContainer = props => {
  const result = useFragment(
    ParticipativeModuleResultsFormFieldContainer_result,
    props.result
  );

  const { title, answersCount, participationRatio } = result;

  const { displayQuestionsLabel, displayParticipationData, TitleLevel } = props;

  const t = useFormatMessage();

  const answersLabel = useMemo(() => {
    if (!displayParticipationData) return null;

    return t(intlMessages.answersLabel, { answersCount });
  }, [answersCount, displayParticipationData, t]);

  const participationLabel = useMemo(() => {
    if (!displayParticipationData) return null;

    return t(intlMessages.participationLabel, {
      participationRatio: Math.round(participationRatio * 100, 2)
    });
  }, [displayParticipationData, participationRatio, t]);

  const noAnswersAvailable = useMemo(() => {
    if (answersCount > 0) return null;

    return t(intlMessages.noAnswersAvailable);
  }, [answersCount, t]);

  const displayHeader = useMemo(() => {
    return displayQuestionsLabel || participationLabel;
  }, [displayQuestionsLabel, participationLabel]);

  return (
    <div className="participative-module-results-form-field">
      {displayHeader && (
        <div className="margin-bottom-sm">
          {displayQuestionsLabel && (
            <TitleLevel className="participative-module-results-form-field-label text-subtitle-section margin-bottom-xxs">
              {title}
            </TitleLevel>
          )}

          {participationLabel && (
            <div className="participative-module-results-form-field-participation text-small">
              <span className="participative-module-results-form-field-participation-answers">
                {answersLabel}
              </span>

              <span className="participative-module-results-form-field-participation-separator margin-x-xxs">
                /
              </span>

              <span className="participative-module-results-form-field-participation-ratio">
                {participationLabel}
              </span>
            </div>
          )}
        </div>
      )}

      {answersCount > 0 && props.children}

      {answersCount === 0 && (
        <div className="participative-module-results-form-field-no-data text-small">
          <span className="text-muted">{noAnswersAvailable}</span>
        </div>
      )}
    </div>
  );
};

const ParticipativeModuleResultsFormFieldContainer_result = graphql__3bf326f8db9b0437ca53;

export default ParticipativeModuleResultsFormFieldContainer;

const intlMessages = {
  answersLabel: {
    id: "participativeModuleResults.formField.answersLabel",
    defaultMessage: "{answersCount} répondants"
  },
  participationLabel: {
    id: "participativeModuleResults.formField.participationLabel",
    defaultMessage: "{participationRatio}% de participation"
  },
  noAnswersAvailable: {
    id: "participativeModuleResults.formField.noAnswersAvailable",
    defaultMessage: "Aucune réponse pour le moment"
  }
};
